import { BLOCK_CLASSES as e } from "../../constants.js";
//#region src/specs/nodes/placeholder-spec.ts
var t = {
	inline: !1,
	attrs: { type: { default: "placeholder" } },
	group: "block",
	atom: !0,
	allowGapCursor: !1,
	parseDOM: [],
	toDOM() {
		return ["div", { class: `${e.placeholder}` }];
	}
};
//#endregion
export { t as placeholderSpec };
